function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { Action } from "./Text";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";

// we want buttons to have the same height whether they have icons or no
var getPadding = function getPadding(size, hasIcon) {
  if (size === "l") return hasIcon ? RAW_cssValue("18px 24px") : RAW_cssValue("19px 24px");
  if (size === "m") return hasIcon ? RAW_cssValue("12px 18px") : RAW_cssValue("13px 18px");
  return RAW_cssValue("12px 18px");
};

export var Button = function Button(_ref) {
  var onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      disabled = _ref.disabled,
      width = _ref.width,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? "primary" : _ref$kind,
      style = _ref.style,
      icon = _ref.icon,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "l" : _ref$size,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      ariaDescribedby = _ref["aria-describedby"],
      ariaControls = _ref["aria-controls"],
      ariaExpanded = _ref["aria-expanded"],
      id = _ref.id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      href = _ref.href,
      className = _ref.className,
      target = _ref.target,
      tabIndex = _ref.tabIndex;
  var Element = href ? "a" : "button";
  return _jsxs(Element, {
    sx: _objectSpread(_objectSpread(_objectSpread({
      width: width,
      border: "none",
      position: "relative",
      backgroundColor: "transparent"
    }, buttonStyle), getButtonColorStyle(kind, disabled)), {}, {
      padding: getPadding(size, !!icon)
    }),
    disabled: disabled,
    onClick: !disabled ? onClick : undefined,
    onBlur: onBlur,
    className: className,
    "data-test-name": dataTestName,
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedby,
    type: href ? undefined : type,
    target: target,
    href: href,
    tabIndex: tabIndex,
    style: style,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    id: id,
    children: [icon && /*#__PURE__*/React.isValidElement(icon) ? _jsx("div", {
      sx: {
        marginRight: children ? "dt_xs" : "0",
        position: "relative"
      },
      children: size === "s" && !icon.props.size ? /*#__PURE__*/React.cloneElement(icon, {
        size: "s"
      }) : icon
    }) : null, _jsx(Action, {
      compact: size === "s",
      children: children
    })]
  });
};

var getButtonColorStyle = function getButtonColorStyle(kind, disabled) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, kind === "primary" && primaryStyle || {}), kind === "secondary" && secondaryStyle || {}), kind === "tertiary" && tertiaryStyle || {}), kind === "destructive" && destructiveStyle || {}), kind === "plus" && plusStyle || {}), kind === "like" && likeActionStyle || {}), disabled && disabledStyle || {}), disabled && kind === "tertiary" && disabledTertiaryStyle || {});
};

var buttonStyle = {
  borderRadius: RAW_cssValue("40px"),
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  span: {
    color: "dt_white",
    whiteSpace: "nowrap"
  },
  svg: {
    verticalAlign: "middle"
  }
};
var primaryStyle = {
  backgroundColor: "dt_aqua50",
  ":hover, :focus": {
    backgroundColor: "dt_aqua60"
  },
  ":active": {
    backgroundColor: "dt_aqua40"
  }
};
var secondaryStyle = {
  backgroundColor: "dt_taro20",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_taro90"
  }),
  "svg path": {
    fill: "dt_taro90"
  },
  ":hover, :focus": {
    backgroundColor: "dt_taro30",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro90"
    }),
    "svg path": {
      fill: "dt_taro90"
    }
  },
  ":active": {
    backgroundColor: "dt_taro20",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro50"
    }),
    "svg path": {
      fill: "dt_taro50"
    }
  }
};
var tertiaryStyle = {
  backgroundColor: "dt_white",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_aqua50"
  }),
  "svg path": {
    fill: "dt_aqua50"
  },
  ":hover, :focus": {
    backgroundColor: "dt_aqua10",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_aqua60"
    }),
    "svg path": {
      fill: "dt_aqua60"
    }
  },
  ":active": {
    backgroundColor: "dt_aqua10",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_aqua40"
    }),
    "svg path": {
      fill: "dt_aqua40"
    }
  }
};
var plusStyle = {
  backgroundColor: "dt_grape50",
  ":hover, :focus": {
    backgroundColor: "dt_grape50"
  },
  ":active": {
    backgroundColor: "dt_grape40"
  }
};
var destructiveStyle = {
  backgroundColor: "dt_watermelon50",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_white"
  }),
  ":hover, :focus": {
    backgroundColor: "dt_watermelon60"
  },
  ":active": {
    backgroundColor: "dt_watermelon40"
  }
};
var likeActionStyle = {
  backgroundColor: "dt_watermelon20",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_watermelon50"
  }),
  "svg path": {
    fill: "dt_watermelon50"
  }
};
var disabledStyle = {
  cursor: "not-allowed",
  backgroundColor: "dt_taro10",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_taro30"
  }),
  "svg path": {
    fill: "dt_taro30"
  },
  ":hover, :focus": {
    backgroundColor: "dt_taro10",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro30"
    }),
    "svg path": {
      fill: "dt_taro30"
    }
  },
  ":active": {
    backgroundColor: "dt_taro10",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro30"
    }),
    "svg path": {
      fill: "dt_taro30"
    }
  }
};
var disabledTertiaryStyle = {
  backgroundColor: "dt_white",
  span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
    color: "dt_taro30"
  }),
  "svg path": {
    fill: "dt_taro30"
  },
  ":hover": {
    backgroundColor: "dt_white",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro30"
    }),
    "svg path": {
      fill: "dt_taro30"
    }
  },
  ":active, :focus": {
    backgroundColor: "dt_white",
    span: _objectSpread(_objectSpread({}, buttonStyle.span), {}, {
      color: "dt_taro30"
    }),
    "svg path": {
      fill: "dt_taro30"
    }
  }
};
//# sourceMappingURL=Button.js.map